import React from 'react';
import {BooleanInputProps} from '../shared/props';
import scss from './RsnRadioButton.module.scss';

export function RsnRadioButton({className = '', inputRef, ...props}: BooleanInputProps) {
    return <input {...props} ref={inputRef} type='radio' className={`${className} ${scss.input}`} />;
}
RsnRadioButton.displayName = 'RsnRadioButton';
